import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";
import type { IModuleTitleRichTextFields } from "@types-contentful";

export function buildFaqPageJsonLd(
	items: IModuleTitleRichTextFields[],
	pageUrl?: string,
) {
	const mainEntity = (items ?? [])
		.map((i) => {
			const question = (i.title ?? "").trim();
			const answerText = i.content
				? documentToPlainTextString(i.content).trim()
				: "";

			if (!question || !answerText) return null;

			return {
				"@type": "Question" as const,
				name: question,
				acceptedAnswer: {
					"@type": "Answer" as const,
					text: answerText,
				},
			};
		})
		.filter((x): x is NonNullable<typeof x> => Boolean(x));

	if (!mainEntity.length) return null;

	return {
		"@context": "https://schema.org",
		"@type": "FAQPage" as const,
		...(pageUrl ? { "@id": `${pageUrl}#faq` } : {}),
		mainEntity,
	};
}
